import CitaService from "@/services/CitaService";
import { bool } from "yup";
//this.$store.state.user.users,current_page
export const cita = {
    namespace:true,
    state: {citas:{},fail:true,searchNotification:0,paramether:[] },
    actions: {
        async getListCita({commit},pageNumber){
            return await CitaService.getlist(pageNumber).then(
                response=>{    
                    commit('setCita',response);                    
                },
                error => {
                    commit('setFailure');
                    return Promise.reject(error);
                })
        },
        async searchListCita({commit},search){          
            return await CitaService.getSearch(search).then (
                response =>{                    
                    commit('setCita',response)
                     commit('setSearchNotify',1)
                     commit('setParamether',search)
                },
                error=>{
                    commit('setFailure',false)
                    return Promise.reject(error)
                }
            );
        },
        async filterListCita({commit},search){          
            return await CitaService.getfilter(search).then (
                response =>{                    
                    commit('setCita',response)
                     commit('setSearchNotify',1)
                     commit('setParamether',search)
                },
                error=>{
                    commit('setFailure',false)
                    return Promise.reject(error)
                }
            );
        },
        //  async filterListCitaTemp({commit},search){          
        //     return await CitaService.getfilterTemp(search).then (
        //         response =>{                    
        //             commit('setCita',response)
        //              commit('setSearchNotify',1)
        //              commit('setParamether',search)
        //         },
        //         error=>{
        //             commit('setFailure',false)
        //             return Promise.reject(error)
        //         }
        //     );
        // },
        
    },
  mutations: {
    setCita(state,data){
        state.citas = data
    },
    setFailure(state,data){
        state.fail = data
    },
    setCurrentPage(state,data){
        state.citas.current_page = data
    },
    setSearchNotify(state,data){        
        state.searchNotification = data
    },
    setParamether(state,paramSearch){        
        state.paramether = paramSearch
    }
  }
};